import { patch } from '../../../helpers/fetch';

import { buildURL, urls } from '../../../helpers/urls';

// eslint-disable-next-line import/prefer-default-export
export const updateSlideshow = (event) => {
  const url = buildURL(urls.events.root, 'slideshow');
  return patch(url, event);
};
